import { Grid, Typography, Box, Button, TextField } from "@material-ui/core";
import { useMountAPI } from "../hooks/APICall";
import {
  WHITE,
  GREEN_PRIMRY,
  BLUE_COLOR,
  ERROR_COLOR,
  ORANGE_COLOR,
  BLUE_PRIMARY,
} from "../utils/const";
import Call from "../service/API";
import useCustomState from "../hooks/State";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import Loading from "../components/loading";
import SuccessModal from "../components/generalModals/SuccessModal";
import DeleteIcon from "@material-ui/icons/Delete";

const HowToCalculateBill = (props) => {
  const serial = props.match.params.counterSerial;

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("ثبت اطلاعات با موفقیت انجام شد.");
  const successStyle = useCustomState({ successColor: GREEN_PRIMRY });

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const counterInfoIsLoading = useCustomState(true);
  const counterInfo = useCustomState({ category: "" });

  const billRecords = useCustomState([]);

  const counterUtils = {
    serial: serial,
    counterInfo: counterInfo,
    isLoading: counterInfoIsLoading,
    billRecords: billRecords,
  };

  useMountAPI(fetchCounterInfo, counterUtils);

  const handleFromValueChanged = (e) => {
    const newValue = e.target.value;
    const id = e.target.id.split("-")[1];
    // console.log(newValue, id);
    const records = [...billRecords.value];
    records.map((r, idx) => {
      if (r.id == id) {
        r.v1 = newValue;
        r.isNew = false;
        r.error = false;
        r.text = "";
      }
    });
    // console.log(records);
    billRecords.handleChange(records);
  };

  const handleToValueChanged = (e) => {
    const newValue = e.target.value;
    const id = e.target.id.split("-")[1];
    // console.log(newValue, id);
    const records = [...billRecords.value];
    records.map((r, idx) => {
      if (r.id == id) {
        r.v2 = newValue;
        r.isNew = false;
        r.error = false;
        r.text = "";
      }
    });
    // console.log(records);
    billRecords.handleChange(records);
  };

  const handleUnitPriceChanged = (e) => {
    const newValue = e.target.value;
    const id = e.target.id.split("-")[1];
    // console.log(newValue, id);
    const records = [...billRecords.value];
    records.map((r, idx) => {
      if (r.id == id) {
        r.k = newValue;
        r.isNew = false;
        r.error = false;
        r.text = "";
      }
    });
    // console.log(records);
    billRecords.handleChange(records);
  };

  const addBillRecord = () => {
    const numRecords = billRecords.value.length;
    let newRecord = billRecords.value.filter((r) => r.isNew === true);
    if (newRecord.length === 0) {
      const records = [...billRecords.value];
      newRecord = {
        v1: "",
        v2: "",
        k: "",
        id: numRecords + 1,
        isNew: true,
        error: false,
        text: "",
      };
      records.push(newRecord);
      billRecords.handleChange(records);
    } else {
      return;
    }
  };

  const deleteRecord = (e) => {
    const id = e.currentTarget.id.split("-")[1];
    const records = [...billRecords.value];
    let find = false;
    const newRecords = [];
    records.map((r) => {
      if (r.id == id) {
        find = true;
      } else {
        if (find) {
          r.id = r.id - 1;
          newRecords.push(r);
        } else {
          newRecords.push(r);
        }
      }
    });
    billRecords.handleChange(newRecords);
  };

  const registerRecords = () => {
    let hasError = false;
    const records = [...billRecords.value];
    records.map((r1, idxi) => {
      if (Number(r1.v1) < 0 || Number(r1.v2) < 0 || Number(r1.k) < 0) {
        hasError = true;
        r1.error = true;
        r1.text = "لطفا مقدار این ورودی را بررسی کنید.";
      }
      records.map((r2, idxj) => {
        if (r1.id !== r2.id) {
          if (Number(r1.v1) >= Number(r2.v1) && Number(r1.v1) < Number(r2.v2)) {
            hasError = true;
            r1.error = true;
            r2.error = true;
            r1.text = "لطفا مقدار این ورودی را بررسی کنید.";
            r2.text = "لطفا مقدار این ورودی را بررسی کنید.";
          } else if (
            Number(r1.v2) > Number(r2.v1) &&
            Number(r1.v2) <= Number(r2.v2)
          ) {
            hasError = true;
            r1.error = true;
            r2.error = true;
            r1.text = "لطفا مقدار این ورودی را بررسی کنید.";
            r2.text = "لطفا مقدار این ورودی را بررسی کنید.";
          }
        }
      });
    });
    if (hasError) {
      billRecords.handleChange(records);
      return;
    }
    const billInfo = [];
    records.map((r) => {
      if (r.v1.length > 0 && r.v2.length > 0 && r.k.length > 0) {
        const record = {
          v1: r.v1,
          v2: r.v2,
          k: r.k,
        };
        billInfo.push(record);
      }
    });

    const counterInformation = counterInfo.value;
    counterInformation.information.billInfo = billInfo;

    const data = {
      water_meter_serial: counterInformation.serial,
      water_meter_name: counterInformation.name,
      water_meter_location: counterInformation.location,
      other_information: counterInformation.information,
      water_meter_validation: counterInformation.validation,
      water_meter_activation: counterInformation.activation,
      water_meter_condition: counterInformation.orderable,
      water_meter_module_id: counterInformation.moduleId
        ? counterInformation.moduleId
        : "",
      water_meter_project_id: counterInformation.projectId,
      water_meter_user_id: counterInformation.userId,
    };

    // console.log("sent data is: ", data);

    Call("POST", "watermeters/admin/edit", data)
      .then((response) => {
        // console.log(response);
        if (response.data.code === 200) {
          successMessage.handleChange("ثبت اطلاعات با موفقیت انجام شد.");
          successStyle.handleChange({ successColor: GREEN_PRIMRY });
          openSuccessModal();
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          successMessage.handleChange(
            "مشکلی در ثبت اطلاعات رخ داده است. خطای " + data.code
          );
          successStyle.handleChange({ successColor: ERROR_COLOR });
          openSuccessModal();
        }
      });
  };

  const renderCounterInfoTable = () => {
    if (counterInfoIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      const categoryStyle = {
        color: "#fff",
        backgroundColor: "green",
        fontSize: "12px",
        borderRadius: "4px",
        paddingRight: "6px",
        paddingLeft: "6px",
        marginRight: "8px",
      };
      const validStyle = { ...categoryStyle };
      const activeStyle = { ...categoryStyle };
      if (counterInfo.value.category.includes("آب")) {
        categoryStyle.backgroundColor = BLUE_COLOR;
      } else if (counterInfo.value.category.includes("برق")) {
        categoryStyle.backgroundColor = ERROR_COLOR;
      } else {
        categoryStyle.backgroundColor = ORANGE_COLOR;
      }

      if (counterInfo.value.validation) {
        validStyle.backgroundColor = GREEN_PRIMRY;
      } else {
        validStyle.backgroundColor = ERROR_COLOR;
      }
      if (counterInfo.value.activation) {
        activeStyle.backgroundColor = GREEN_PRIMRY;
      } else {
        activeStyle.backgroundColor = ERROR_COLOR;
      }

      const category = (
        <span style={categoryStyle}>
          {convertNumbers(counterInfo.value.category)}
        </span>
      );

      const validation = counterInfo.value.validation ? (
        <span style={validStyle}>{"تایید شده"}</span>
      ) : (
        <span style={validStyle}>{"تایید نشده"}</span>
      );
      const activation = counterInfo.value.activation ? (
        <span style={activeStyle}>{"فعال"}</span>
      ) : (
        <span style={activeStyle}>{"غیر فعال"}</span>
      );
      return (
        <TableContainer component={Paper} style={{ marginBottom: "24px" }}>
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>نام کنتور</TableCell>
                <TableCell align={"center"}>شماره سریال</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>نوع</TableCell>
                <TableCell align={"center"}>وضعیت تایید</TableCell>
                <TableCell align={"center"}>وضعیت فعالیت</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align={"center"}>
                  {convertNumbers(counterInfo.value.name)}
                </TableCell>
                <TableCell align={"center"}>
                  {convertNumbers(counterInfo.value.serial)}
                </TableCell>
                <TableCell align={"center"}>{category}</TableCell>
                <TableCell align={"center"}>{counterInfo.value.type}</TableCell>
                <TableCell align={"center"}>{validation}</TableCell>
                <TableCell align={"center"}>{activation}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCounterInfo = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "16px", marginTop: "48px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>اطلاعات کنتور</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
          }}
        >
          {renderCounterInfoTable()}
        </Grid>
      </>
    );
  };

  const renderOneBillRecord = (record) => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={1}
          lg={1}
          style={{ position: "relative" }}
        >
          <div style={{ position: "absolute", left: "50%", bottom: "0" }}>
            <Typography>{convertNumbers("رکورد " + record.id)}</Typography>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          style={{ paddingRight: "5%", paddingLeft: "5%" }}
        >
          <TextField
            error={record.error}
            helperText={record.text}
            id={"from-" + record.id}
            onChange={handleFromValueChanged}
            value={record.v1}
            fullWidth
            variant="standard"
            label="از مقدار"
            type={"number"}
            InputLabelProps={{
              style: {
                fontFamily: "Vazir",
              },
            }}
            size="small"
          ></TextField>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          style={{ paddingRight: "5%", paddingLeft: "5%" }}
        >
          <TextField
            error={record.error}
            helperText={record.text}
            onChange={handleToValueChanged}
            value={record.v2}
            fullWidth
            type={"number"}
            variant="standard"
            label="تا مقدار"
            id={"to-" + record.id}
            InputLabelProps={{
              style: {
                fontFamily: "Vazir",
              },
            }}
            size="small"
          ></TextField>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ paddingRight: "5%", paddingLeft: "5%" }}
        >
          <TextField
            error={record.error}
            helperText={record.text}
            onChange={handleUnitPriceChanged}
            value={record.k}
            fullWidth
            type={"number"}
            variant="standard"
            label="قیمت هر واحد مصرف (بر حسب ریال)"
            id={"price-" + record.id}
            InputLabelProps={{
              style: {
                fontFamily: "Vazir",
              },
            }}
            size="small"
          ></TextField>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={1}
          lg={1}
          //   style={{ paddingRight: "5%", paddingLeft: "5%" }}
        >
          {/* <Button
            onClick={deleteRecord}
            id={"delete-" + record.id}
            style={{ backgroundColor: ERROR_COLOR, color: WHITE }}
          >
            حذف رکورد
          </Button> */}
          <DeleteIcon
            onClick={deleteRecord}
            id={"delete-" + record.id}
            style={{ color: ERROR_COLOR, cursor: "pointer", marginTop: "16px" }}
          />
        </Grid>
      </>
    );
  };

  const renderBillRecords = () => {
    if (counterInfoIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      // console.log(billRecords.value);
      if (billRecords.value.length === 0) {
        return (
          <div style={{ position: "relative", width: "100%", height: "160px" }}>
            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <Typography>رکوردی برای محاسبه قیمت ثبت نشده است.</Typography>
            </div>
          </div>
        );
      } else {
        return billRecords.value.map((r, idx) => {
          return (
            <Grid key={idx} container style={{ marginBottom: "24px" }}>
              {renderOneBillRecord(r)}
            </Grid>
          );
        });
      }
    }
  };

  const renderWarnings = () => {
    if (billRecords.value.length === 0) {
      return null;
    } else {
      return (
        <>
          <Typography style={{ color: ERROR_COLOR, fontSize: "14px" }}>
            * حتما از اعداد انگلیسی استفاده نمایید.
          </Typography>
          <Typography style={{ color: ERROR_COLOR, fontSize: "14px" }}>
            * پس از ایجاد تغییرات لازم برای ثبت نهایی تغییرات حتما از دکمه ثبت
            نهایی استفاده نمایید.
          </Typography>
        </>
      );
    }
  };

  const renderBillCalculation = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "24px", marginTop: "16px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            رکوردهای محاسبه قیمت قبض
          </Typography>
          {renderWarnings()}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
            paddingBottom: "24px",
          }}
        >
          {renderBillRecords()}
        </Grid>
      </>
    );
  };

  const renderBtns = () => {
    if (counterInfoIsLoading.value) {
      return null;
    } else {
      const registerRecordsActive =
        billRecords.value.length === 0 ? false : true;
      return (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: "16px" }}
          >
            <Button
              onClick={registerRecords}
              //   disabled={!registerRecordsActive}
              style={{
                backgroundColor: GREEN_PRIMRY,
                color: WHITE,
                // opacity: registerRecordsActive ? "1" : "0.5",
              }}
            >
              ثبت نهایی
            </Button>
            <Button
              onClick={addBillRecord}
              style={{
                backgroundColor: BLUE_PRIMARY,
                color: WHITE,
                marginRight: "8px",
              }}
            >
              افزودن رکورد جدید
            </Button>
          </Grid>
        </>
      );
    }
  };

  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={successStyle.value}
      />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>
              نحوه محاسبه قبض
            </Typography>
          </Box>
          <Grid container>
            {renderCounterInfo()}
            {renderBillCalculation()}
            {renderBtns()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default HowToCalculateBill;

const processCounterInfo = (info) => {
  const billRecords = info.other_information.billInfo
    ? info.other_information.billInfo
    : [];
  billRecords.map((r, idx) => {
    r.id = idx + 1;
    r.error = false;
    r.text = "";
  });
  const processedCounterInfo = {
    activation: info.water_meter_activation,
    orderable: info.water_meter_condition,
    name: info.water_meter_name,
    serial: info.water_meter_serial,
    category: info.water_meter_tag_info.water_meter_tag_name,
    type: info.water_meter_type_info.water_meter_type_name,
    validation: info.water_meter_validation,
    billRecords: billRecords,
    location: info.water_meter_location,
    information: info.other_information,
    moduleId: info.water_meter_module_info.water_meter_module_id,
    projectId: info.water_meter_project_info.project_id,
    userId: info.water_meter_user_info.user_id,
  };
  return processedCounterInfo;
};

const fetchCounterInfo = (utils) => {
  const serial = utils.serial;
  const isLoading = utils.isLoading;
  const counterInfo = utils.counterInfo;
  const billRecords = utils.billRecords;

  const data = {
    water_meter_serial: serial,
  };

  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      // console.log("fetch counter info: ", response);
      if (response.data.code == 200) {
        const processedCounterInfo = processCounterInfo(response.data.data);
        counterInfo.handleChange(processedCounterInfo);
        billRecords.handleChange(processedCounterInfo.billRecords);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
